var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"vk-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('svg-icon',{staticClass:"vk-btn__icon",attrs:{"icon-name":"vk","size":"30"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }